import dayjs from "dayjs";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
dayjs.extend(LocalizedFormat);
export default function getDayjsFormatter(format) {
  var _dayjs$Ls$dayjs$local;

  return {
    formatDate: function formatDate(date) {
      return dayjs(date).format(format);
    },
    parseDate: function parseDate(str) {
      return dayjs(str, format).toDate();
    },
    placeholder: format != null && format.toLowerCase().includes("l") ? (_dayjs$Ls$dayjs$local = dayjs.Ls[dayjs.locale()]) == null ? void 0 : _dayjs$Ls$dayjs$local.formats[format.toUpperCase()] : format
  };
}